// extracted by mini-css-extract-plugin
export var grid = "_5-5";
export var layout = "_5-0";
export var leftColumn = "_5-1";
export var leftInner = "_5-2";
export var rightColumn = "_5-3";
export var rightInner = "_5-4";